import React from 'react';
import styled from 'styled-components';

type DividerProps = React.HTMLAttributes<HTMLDivElement> & {
  text?: string;
  borderSize?: number;
};

export const Divider = ({ text = 'or', borderSize = 1, ...props }: DividerProps): JSX.Element => (
  <StyledDivider borderSize={borderSize} {...props}>
    {text}
  </StyledDivider>
);

const StyledDivider = styled.div<{ borderSize: number }>`
  align-items: center;
  color: #464f53;
  display: flex;
  font-size: 14px;
  line-height: ${23 / 14};
  margin: 20px 0;
  width: 100%;

  &::before,
  &::after {
    border-top: ${({ borderSize }) => borderSize}px solid ${({ theme }) => theme.colors.blueGrey[80]};
    content: '';
    flex: 1;
  }

  &::before {
    margin-right: 20px;
  }

  &::after {
    margin-left: 20px;
  }
`;
